<div class="frame" #frame></div>
<p class="frame-time" *ngIf="time && focusOnPreview">
  <span class="time">{{ time | appTime }}</span>
</p>
